module.exports = __webpack_public_path__ + "static/media/icons8-xls-filled.28c05215.svg";